// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4845":"e6a6efc6","5031":"e6a6efc6","5607":"e6a6efc6","5765":"8caf20b7","6550":"362a239d"}[chunkId] + ".chunk.css";
};